var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h-page',{attrs:{"id":"app"}},[_c('h-layout',[_c('h-layout-header',[_c('Header')],1),_c('h-layout-content',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }